import React from 'react';
import './CreatorAssignmentConfirmationModal.css';
import { CheckCircle } from 'lucide-react';

function CreatorAssignmentConfirmationModal({ 
  isOpen, 
  onClose, 
  assignments = [], 
  onBackToCreatorList 
}) {
  if (!isOpen || !assignments || assignments.length === 0) return null;

  return (
    <div className="creator-assignment-confirmation-overlay" onClick={onClose}>
      <div className="creator-assignment-confirmation-modal" onClick={(e) => e.stopPropagation()}>
        {/* Success Icon */}
        <div className="creator-assignment-confirmation-icon">
          <CheckCircle size={64} />
        </div>

        {/* Title */}
        <h2 className="creator-assignment-confirmation-title">
          Creator{assignments.length > 1 ? 's' : ''} Confirmed
        </h2>
        
        {/* Subtitle */}
        <p className="creator-assignment-confirmation-subtitle">
          {assignments.length > 1 
            ? `${assignments.length} creators have been successfully assigned`
            : 'The creator has been successfully assigned to your campaign'
          }
        </p>

        {/* Creator List */}
        <div className="creator-assignment-confirmation-list">
          {assignments.map((assignment, index) => (
            <div 
              key={assignment.creator.id || index} 
              className="creator-assignment-confirmation-item"
            >
              {/* Creator Info */}
              <div className="creator-assignment-confirmation-creator">
                <img 
                  src={assignment.creator.avatar || assignment.creator.profileImage || assignment.creator.image || '/creatorimages/creatorpic1v2-min.png'} 
                  alt={assignment.creator.name || assignment.creator.handle}
                  className="creator-assignment-confirmation-avatar"
                />
                <div className="creator-assignment-confirmation-creator-info">
                  <h3 className="creator-assignment-confirmation-creator-name">
                    {assignment.creator.name || 'Creator'}
                  </h3>
                  <span className="creator-assignment-confirmation-creator-handle">
                    {(() => {
                      const handle = assignment.creator.handle || '';
                      // Remove any leading @ symbols and add exactly one
                      const cleaned = handle.replace(/^@+/, '');
                      return cleaned ? `@${cleaned}` : '@creator';
                    })()}
                  </span>
                </div>
              </div>

              {/* Assignments Details */}
              <div className="creator-assignment-confirmation-details">
                {assignment.assignments && assignment.assignments.length > 0 ? (
                  assignment.assignments.map((assign, assignIndex) => (
                    <div key={assignIndex} className="creator-assignment-confirmation-assignment">
                      {assign.brief && (
                        <div className="creator-assignment-confirmation-brief">
                          <span className="creator-assignment-confirmation-label">Brief:</span>
                          <span className="creator-assignment-confirmation-value">{assign.brief.title || assign.brief.name || assign.briefId}</span>
                        </div>
                      )}
                      {assign.scripts && assign.scripts.length > 0 && (
                        <div className="creator-assignment-confirmation-scripts">
                          <span className="creator-assignment-confirmation-label">Scripts:</span>
                          <div className="creator-assignment-confirmation-scripts-list">
                            {assign.scripts.map((script, scriptIndex) => (
                              <span key={scriptIndex} className="creator-assignment-confirmation-script-badge">
                                {script.name || script.title || `Script ${script.id}`}
                              </span>
                            ))}
                          </div>
                        </div>
                      )}
                    </div>
                  ))
                ) : (
                  <div className="creator-assignment-confirmation-no-assignments">
                    Assigned to campaign
                  </div>
                )}
              </div>
            </div>
          ))}
        </div>

        {/* Action Button */}
        <button 
          className="creator-assignment-confirmation-button"
          onClick={onBackToCreatorList || onClose}
        >
          Back to Creator List
        </button>
      </div>
    </div>
  );
}

export default CreatorAssignmentConfirmationModal;


